module.exports = __webpack_public_path__ + "img/people-recommendations.36a09af2.svg";